import { getConfig } from '../../Config/ApplicationConfig';
import { Permission } from '../../Config/PermissionConfig';
import { getExecutor } from '../../Shared/HttpRequestExecutor';
import { UserIUser } from './AuthorisationModels';

export function getCurrentPermissions(): Promise<Permission[]> {
    return getExecutor(getConfig().apiEndpoints.authorisation).get<Permission[]>(`api/v1/users/me/permissions`);
}

export function getCurrentUser(): Promise<UserIUser> {
    return getExecutor(getConfig().apiEndpoints.authorisation).get<UserIUser>(`api/v1/users/me`);
}

export function getSystemContact(): Promise<UserIUser> {
    return getExecutor(getConfig().apiEndpoints.authorisation).get<UserIUser>(`api/v1/users/system-contact/`);
}
